'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FavoriteButton = undefined;

var _FavoriteWindow = require('./FavoriteWindow.js');

var _RenameWindow = require('./RenameWindow.js');

var _SharingWindow = require('./SharingWindow.js');

var _InterpretationWindow = require('./InterpretationWindow.js');

var _LinkWindow = require('./LinkWindow.js');

var _TranslateWindow = require('./TranslateWindow.js');

var FavoriteButton = exports.FavoriteButton = undefined;

exports.FavoriteButton = FavoriteButton = function FavoriteButton(c) {
    var appManager = c.appManager,
        uiManager = c.uiManager,
        instanceManager = c.instanceManager,
        i18n = c.i18nManager.get();

    return Ext.create('Ext.button.Button', {
        text: i18n.favorites,
        menu: {},
        handler: function handler(b) {
            b.menu = Ext.create('Ext.menu.Menu', {
                closeAction: 'destroy',
                shadow: false,
                showSeparator: false,
                items: function () {
                    var getTitle = function getTitle(text) {
                        return text + '&nbsp;&nbsp;&nbsp;';
                    };

                    var newItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.new_),
                        iconCls: 'ns-menu-item-favorite-new',
                        disabled: !instanceManager.isStateCurrent(),
                        handler: function handler() {
                            if (instanceManager.isStateUnsaved()) {
                                uiManager.confirmUnsaved(i18n.new_favorite, function () {
                                    instanceManager.setState();
                                });
                            } else {
                                instanceManager.setState();
                            }
                        }
                    });
                    uiManager.reg(newItem, 'newItem');

                    var openItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.open),
                        iconCls: 'ns-menu-item-favorite-open',
                        handler: function handler() {
                            uiManager.reg((0, _FavoriteWindow.FavoriteWindow)(c, 'open'), 'favoriteWindow').show();
                        }
                    });
                    uiManager.reg(openItem, 'openItem');

                    var saveItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.save),
                        iconCls: 'ns-menu-item-favorite-save',
                        disabled: !instanceManager.isStateDirty(),
                        handler: function handler() {
                            var layout = instanceManager.getStateCurrent(),
                                favorite = instanceManager.getStateFavorite();

                            if (!favorite) {
                                saveAsItem.handlerFn();
                                return;
                            }

                            layout.apply(favorite, ['id', 'name', 'description']);

                            layout.clone().put(layout.id, function () {
                                instanceManager.getById(layout.id, function (layout, isFavorite) {
                                    instanceManager.getReport(layout, isFavorite, false, false, function () {
                                        uiManager.unmask();
                                    });
                                });
                            }, true, true);
                        }
                    });
                    uiManager.reg(saveItem, 'saveItem');

                    var saveAsItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.save_as),
                        iconCls: 'ns-menu-item-favorite-save',
                        disabled: !instanceManager.isStateCurrent(),
                        handlerFn: function handlerFn() {
                            (0, _FavoriteWindow.FavoriteWindow)(c, 'saveas').show();
                        },
                        handler: function handler() {
                            this.handlerFn();
                        }
                    });
                    uiManager.reg(saveAsItem, 'saveAsItem');

                    var renameItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.rename),
                        iconCls: 'ns-menu-item-favorite-rename',
                        disabled: !instanceManager.isStateFavorite(),
                        handler: function handler() {
                            (0, _RenameWindow.RenameWindow)(c, instanceManager.getStateFavorite()).show();
                        }
                    });
                    uiManager.reg(saveAsItem, 'renameItem');

                    var translateItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.translate),
                        iconCls: 'ns-menu-item-favorite-translate',
                        disabled: !instanceManager.isStateFavorite(),
                        handler: function handler() {
                            (0, _TranslateWindow.TranslateWindow)(c, instanceManager.getStateFavorite()).show();
                        }
                    });
                    uiManager.reg(saveAsItem, 'translateItem');

                    var shareItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.share),
                        iconCls: 'ns-menu-item-favorite-share',
                        disabled: function () {
                            var fav = instanceManager.getStateFavorite();

                            if (fav && (!fav.getAccess() || fav.getAccess().manage)) {
                                return false;
                            }

                            return true;
                        }(),
                        handler: function handler() {
                            instanceManager.getSharingById(instanceManager.getStateFavoriteId(), function (r) {
                                (0, _SharingWindow.SharingWindow)(c, r).show();
                            });
                        }
                    });
                    uiManager.reg(interpretationItem, 'interpretationItem');

                    var interpretationItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.write_interpretation),
                        iconCls: 'ns-menu-item-favorite-interpretation',
                        disabled: !instanceManager.isStateFavorite(),
                        handler: function handler() {
                            instanceManager.getSharingById(instanceManager.getStateFavoriteId(), function (r) {
                                (0, _InterpretationWindow.InterpretationWindow)(c, r).show();
                            });
                        }
                    });
                    uiManager.reg(interpretationItem, 'interpretationItem');

                    var linkItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.get_link),
                        iconCls: 'ns-menu-item-favorite-link',
                        disabled: !instanceManager.isStateFavorite(),
                        handler: function handler() {
                            (0, _LinkWindow.LinkWindow)(c).show();
                        }
                    });
                    uiManager.reg(linkItem, 'linkItem');

                    var deleteItem = Ext.create('Ext.menu.Item', {
                        text: getTitle(i18n.delete_),
                        iconCls: 'ns-menu-item-favorite-delete',
                        disabled: !instanceManager.isStateFavorite(),
                        handler: function handler() {
                            uiManager.confirmDelete(i18n.delete_favorite, function () {
                                instanceManager.getStateFavorite().del(function () {
                                    instanceManager.setState();
                                });
                            });
                        }
                    });
                    uiManager.reg(deleteItem, 'deleteItem');

                    return [newItem, '-', openItem, '-', saveItem, saveAsItem, '-',
                    //discardItem,
                    //'-',
                    renameItem, translateItem, '-', shareItem, interpretationItem, linkItem, '-', deleteItem];
                }(),
                listeners: {
                    show: function show() {
                        uiManager.setAnchorPosition(b.menu, b);
                    },
                    hide: function hide() {
                        b.menu.destroy();
                    },
                    destroy: function destroy(m) {
                        b.menu = null;
                    }
                }
            });

            b.menu.show();
        }
    });
};
//# sourceMappingURL=FavoriteButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/FavoriteButton.js
 ** module id = 57
 ** module chunks = 0 1
 **/